// BRANCH STATUSES
import {CityDTO} from "../types/city/CityDTO";
import voidZoneIcon from "../assets/icons/voidZone.svg"
import mapDefaultIcon from "../assets/icons/map/mapDefaultIcon.png"
import mapDefaultWarningIcon from "../assets/icons/map/mapDefaultWarningIcon.png"
import mapDeliveryIcon from "../assets/icons/map/mapDeliveryIcon.png"
import mapPickUpIcon from "../assets/icons/map/mapPickUpIcon.png"
import mapWarningIcon from "../assets/icons/map/mapWarningIcon.png"
import mouseLeftIcon from "../assets/icons/map/mouseLeftIcon.png"
import spaceIcon from "../assets/icons/map/mapSpaceIcon.png"
import tabIcon from "../assets/icons/map/mapTabIcon.png"
import {InstructionDTO} from "./InstructionDTO";
import {YMapsApi} from "react-yandex-maps";
import {PointDTO} from "../types/geocoder/GeocodeDTO";

export const BRANCH_STATUS_DEFAULT = 0
export const BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP = 1
export const BRANCH_STATUS_MOVE_TO_NEAREST_WITHOUT_PICK_UP = 2
export const BRANCH_STATUS_ONLY_DELIVERY = 3
export const BRANCH_STATUS_ONLY_PICK_UP = 4
export const BRANCH_STATUS_CLOSED = 5

export const DELIVERY = "Доставка"
export const PICK_UP = "Самовывоз"
export const POINT_OUT_OF_ZONE_ALERT_MESSAGE = "Данная точка не находится в зоне доставки!"
export const BRANCH_CANNOT_DELIVER_ALERT_MESSAGE = "В данный локаций доставка временно не работает!"
export const FIND_BRANCH_INSTRUCTION_TEXT = "можно с пробелам"
export const LOADING_TEXT = "Загрузка..."
export const SEARCH_TEXT = "Поиск..."
export const ERROR_TEXT = "Что-то пошло не так"
export const COORDINATES = "coords"
export const ADDRESS_COPIED = "Адрес скопирован"
export const ADDRESS_NOT_FOUND = "Адрес не найден"

// COLORS
export const COLOR_GREEN = "#006F4C"
export const COLOR_YELLOW = "#ffcc00"
export const COLOR_RED = "#fd0000"

export const getBranchStatusText = (mode: number) => {
    switch (mode) {
        case BRANCH_STATUS_DEFAULT:
            return "Работает в обычном режиме"
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP:
            return "Ближайший филиал с самовывоза"
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITHOUT_PICK_UP:
            return "Ближайший филиал без самовывоза"
        case BRANCH_STATUS_ONLY_DELIVERY:
            return "Только доставка"
        case BRANCH_STATUS_ONLY_PICK_UP:
            return "Только самовывоз"
        default:
            return "Закрыт"
    }
}
/** ------------- DEFAULTS ------------- **/
export const KEYWORD_SPACE = "Space"
export const KEYWORD_TAB = "Tab"
export const KEYWORD_ESC = "Escape"
export const KEYWORD_ARROW_DOWN = "ArrowDown"
export const KEYWORD_ARROW_UP = "ArrowUp"
export const KEYWORD_ENTER = "Enter"
export const DEFAULT_COOKING_TIME = 15
export const SEARCH_INPUT_INDEX = -1;
export const DEFAULT_SEARCH_HINT_INDEX = 0;

export const getCities = (cities: CityDTO[] | null | undefined) =>
    cities
        ?.filter(it => it.longitude && it.latitude && it.title?.ru)
        .sort((o1, o2) => (o1?.sorting ?? -1) - (o2?.sorting ?? -1))

export const getBranchStatus = (mode: number) => mode === BRANCH_STATUS_CLOSED ? "danger" : "success"

export const calculateDistanceInKm = (from: PointDTO, to: PointDTO): number => {
    const toRadians = (degrees: number) => (degrees * Math.PI) / 180;
    const R = 6371; // Radius of Earth in km
    const dLat = toRadians(to.latitude - from.latitude);
    const dLon = toRadians(to.longitude - from.longitude);

    const lat1 = toRadians(from.latitude);
    const lat2 = toRadians(to.latitude);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

export const getNearestCity = (cityList: CityDTO[], point: PointDTO): CityDTO | null => {
    let nearestCity: CityDTO | null = null
    let nearestCityDistance: number = Number.MAX_VALUE
    for (let city of cityList) {
        if (city.latitude &&
            city.longitude) {
            const distance = calculateDistanceInKm(point, {latitude: city.latitude, longitude: city.longitude})
            if (distance < nearestCityDistance) {
                nearestCityDistance = distance
                nearestCity = city
            }
        }
    }
    return nearestCity
}

export const getBranchDeliveryColor = (mode: number | undefined) => {
    switch (mode) {
        case BRANCH_STATUS_DEFAULT:
        case BRANCH_STATUS_ONLY_DELIVERY:
            return COLOR_GREEN
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITHOUT_PICK_UP:
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP:
            return COLOR_YELLOW
        default:
            return COLOR_RED
    }
}

export const getBranchPickUpColor = (mode: number | undefined) => {
    switch (mode) {
        case BRANCH_STATUS_DEFAULT:
        case BRANCH_STATUS_ONLY_PICK_UP:
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP:
            return COLOR_GREEN
        default:
            return COLOR_RED
    }
}


export const BELLISSIMO = "Bellissimo"
export const getBranchShortName = (name: string) => name.includes(BELLISSIMO) ? name.substring(BELLISSIMO.length) : name

// MAP CONSTANTS

export const MAP_MODULES =
    'geoObject.addon.balloon,' +
    'geoObject.addon.hint,' +
    'search,' +
    'overlay.Polygon,' +
    'overlay.Placemark'

export const MAP_QUERY = {
    ns: 'use-load-option',
    load: MAP_MODULES,
    apikey: process.env.REACT_APP_YANDEX_MAP_KEY
}


export const MAP_PROPS = (center: number[], onMapClick?: (e: any) => void, onRightMouseClicked?: (e: any) => void, init?: (yMap: YMapsApi) => void, zoom?: number) => ({
    state: MAP_STATE(center, zoom),
    width: "99%",
    height: "99vh",
    onLoad: init,
    onClick: onMapClick,
    onContextMenu: onRightMouseClicked,
    modules: ["geocode"]
})

export const MAP_STATE = (center: number[], zoom: number = 12) => ({
    center, zoom
})

export const FAQ: InstructionDTO[] = [
    {
        id: 1,
        icon: voidZoneIcon,
        description: {
            title: "На этой зоне доставка не принимается"
        }
    },
    {
        id: 2,
        icon: mapDefaultIcon,
        description: {
            title: "Иконка филиала:",
            items: ["Доставка ✅", "Самовывоз ✅"]
        }
    },
    {
        id: 3,
        icon: mapDeliveryIcon,
        description: {
            title: "Иконка филиала:",
            items: ["Доставка ✅", "Самовывоз 🚫"]
        }
    },
    {
        id: 4,
        icon: mapPickUpIcon,
        description: {
            title: "Иконка филиала:",
            items: ["Доставка 🚫", "Самовывоз ✅"]
        }
    },
    {
        id: 5,
        icon: mapWarningIcon,
        description: {
            title: "Иконка филиала:",
            items: ["Доставка 🚫", "Самовывоз 🚫"]
        }
    },
    {
        id: 6,
        icon: mapDefaultWarningIcon,
        description: {
            title: "Доставка осуществляется с ближайшего филиала, но самовывоз можно узнать в деталях филиала‍",
            items: ["Доставка, с ближайшего филиала ✅", "Самовывоз ✅ / 🚫",]
        }
    },
    {
        id: 7,
        icon: mouseLeftIcon,
        description: {
            title: "При нажатии левой кнопкой мыши на карте, можно узнать адрес выбранной точки",
        }
    },
    {
        id: 8,
        icon: tabIcon,
        description: {
            title: "Нажмите, чтобы начать поиск адресов",
        }
    },
    {
        id: 9,
        icon: spaceIcon,
        description: {
            title: "Нажмите для поиска ближайших филиалов‍",
        }
    }
]
